export default "__VITE_ASSET__5eb2a701__"